export const ReferenceIcon = ({ color = "#000000", size = 17, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#reference-clip)">
            <path
                d="M4.50065 4.5V5.83333H10.2273L3.83398 12.2267L4.77398 13.1667L11.1673 6.77333V12.5H12.5007V4.5H4.50065Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="reference-clip">
                <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
            </clipPath>
        </defs>
    </svg>
);
